import React from "react";
import { StepModel } from "../../../models/step.model";
import { WorkflowModel, WorkflowParentInfo } from "../../../models/workflow.model";

interface IWorkflowContext {
  currentWorkflow: WorkflowModel | undefined | null;
  activeStep: number;
  steps: StepModel[];
  reload: () => void;
  ticketNumber?: string;
  workflowParentInfo?: WorkflowParentInfo;
}

const WorkflowContext = React.createContext<IWorkflowContext>({
  currentWorkflow: undefined,
  activeStep: 0,
  steps: [],
  reload: () => {},
});

export default WorkflowContext;
